import { render, staticRenderFns } from "./OptimizationEdit.vue?vue&type=template&id=f257f722"
import script from "./OptimizationEdit.vue?vue&type=script&lang=js"
export * from "./OptimizationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports